module.exports = __webpack_public_path__ + "static/media/users_darkbleu.ceb301dc.svg";